const parcel = {
  pclid: 'eg範例包裹1',
  carrier: 'zhongtong',
  trackingNo: '7537212345678',
  trackingNoPri: '',
  weight: '2340',
  length: '20',
  width: '20',
  height: '20',
  overVwFee: '0',
  overVwWeightAir: '0',
  overVwWaFree: '0',
  status: 'racked',
  statusBrief: '',
  statusAt: '2020-08-24 19:57:01',
  desc: '硬盤',
  freightCollect: '0',
  premiumFee: '0',
  reinforce: '1',
  wrapAcb: '1',
  ippc: '1',
  ctnLbl: '1',
  oobno: '1',
  oobct: '1',
  splitpri: '1',
  oobrm: '1',
  stuffing: '0',
  unboxing: '0',
  ooba: '0',
  sses: '0',
  woodenSpt: '1',
  woodenBox: '0',
  woodenSptCov: '0',
  reoperate: '0',
  specialNeed: '',
  memo: '範例包裹',
  jySrType: 'twp',
  jyStorageAt: '2020-08-24 19:57:01',
  pclError: '',
  pclErrorBrief: '',
  oid: '',
  splice: {},
  extraInfo: {
    hasRawWood: 0,
    snapshots: ['/parcel/2020/0831/01/e257ca4d19fe79bf9b4676311bf5c869_1598838370.560092'],
    snapshotsWoodenSpt: ['/parcel/2020/0829/01/1acf8e2cae06817a0bf0765277f2e4ca_1598666004.ws-before.jpg',
      '/parcel/2020/0829/01/1acf8e2cae06817a0bf0765277f2e4ca_1598666004.ws-before.jpg',
      '/parcel/2020/0829/01/1acf8e2cae06817a0bf0765277f2e4ca_1598666004.ws-after.jpg'],
    snapshotsOoba: ['/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851101.oo-outer.jpg', '/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851102.oo-inner.jpg', '/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851102.oo-inner2.jpg', '/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851102.oo-bad.jpg'],
    snapshotsReinforce: ['/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851101.re-before.jpg', '/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851101.re-after.jpg'],
    snapshotsStuffing: ['/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851102.st-before.jpg', '/parcel/2020/0831/05/1acf8e2cae06817a0bf0765277f2e4ca_1598851102.st-after.jpg'],
    isAllUnclear: 0,
    isAllCcName: 1,
    canTransportAir: 1,
    canTransportSe: 0,
    tpttName: '三星860EVO1TB笔记本SSD固态硬盘硬台式机固盘闪存储盘2.5英寸',
    tpttPic: '//img.alicdn.com/imgextra/i3/2972174697/O1CN011to9Dp1kZGvs440cw_!!0-item_pic.jpg_80x80.jpg',
    tpttAmount: '1029.00',
    tpttPlatform: 'tmall',
    tpTaobaoTradeItems: [{
      traTrackingNo: '75372539265379',
      traDate: '2020-07-22',
      traAmount: '1029.00',
      traFreight: '0.00',
      traSellerName: '三星刚健兴业专卖店',
      traPlatform: 'tmall',
      traOS: 'unknown',
      tiid: '947551',
      itemTradeid: '1136403971219008650',
      itemid: '564861134149',
      itemName: '【範例包裹】三星860EVO1TB笔记本SSD固态硬盘',
      itemOrigPrice: '1599.00',
      itemFinalPrice: '1039.00',
      itemQty: '1',
      itemPic: '//img.alicdn.com/imgextra/i3/2972174697/O1CN011to9Dp1kZGvs440cw_!!0-item_pic.jpg_80x80.jpg',
      itemBrief: '颜色分类：标配+服务支持',
      itemCid: '50013151',
      itemHsName: '硬盘',
      itemTwName: '硬盤',
      itemCcName: '硬盤',
      itemCcMaxQty: '999999',
      itemCcMaxBox: '999',
      itemEmbargoAir: '0',
      itemEmbargoSe: '0',
      itemSrType: 'twt',
      itemMold: '1',
      itemShptBrief: '',
      itemLock: '2',
      updatedAt: '2020-07-31 23:08:08',
      catalogQas: []
    }],
    nameList: [{
      traTrackingNo: '75372539265379',
      traDate: '2020-07-22',
      traAmount: '1029.00',
      traFreight: '0.00',
      traSellerName: '三星刚健兴业专卖店',
      traPlatform: 'tmall',
      traOS: 'unknown',
      tiid: '947551',
      itemTradeid: '1136403971219008650',
      itemid: '564861134149',
      itemName: '送集线器三星860EVO1TB笔记本SSD固态硬盘硬台式机固盘sata3一体机PS4游戏机电脑1T闪存储盘2.5英寸',
      itemOrigPrice: '1599.00',
      itemFinalPrice: '1039.00',
      itemQty: '1',
      itemPic: '//img.alicdn.com/imgextra/i3/2972174697/O1CN011to9Dp1kZGvs440cw_!!0-item_pic.jpg_80x80.jpg',
      itemBrief: '颜色分类：标配+服务支持',
      itemCid: '50013151',
      itemHsName: '硬盘',
      itemTwName: '硬盤',
      itemCcName: '硬盤',
      itemCcMaxQty: '999999',
      itemCcMaxBox: '999',
      itemEmbargoAir: '0',
      itemEmbargoSe: '0',
      itemSrType: 'twt',
      itemMold: '1',
      itemShptBrief: '',
      itemLock: '2',
      updatedAt: '2020-07-31 23:08:08',
      catalogQas: [],
      limitLevel: 0
    }],
    fullNames: '硬盤',
    virtualItem: false,
    hasQa: false,
    showTpItemIndex: 0
  },
  createdAt: '2020-07-31 23:08:08',
  carrierName: '中通快遞',
  statusName: '包裹已上架',
  jySrTypeName: '特貨',
  pclErrorName: '',
  volWeight: '1',
  chgWeight: 0,
  woodenSptFee: 225,
  woodenBoxFee: 300,
  woodenSptCovFee: 425,
  vaorders: [{
    vaOid: 'V3573611141552',
    vaPclid: '547831',
    vaType: 'ws',
    vaUid: '104874',
    vaWhsAddrid: '1024',
    vaAmount: '257',
    vaPayStatus: '9',
    vaPayBrief: 'LGID:159853027426103438',
    vaPaidTime: '1598530274',
    vaStatus: '9',
    createdTime: '1598530274',
    updatedTime: '1598666047',
    createdAt: '2020-08-27 20:11:14',
    updatedAt: '2020-08-29 09:54:07',
    vaTypeName: '打木架',
    parcelField: 'woodenSpt',
    vaPayStatusName: '已付款',
    vaStatusName: '已完成'
  }, {
    vaOid: 'V3580836188753',
    vaPclid: '548910',
    vaType: 'oo',
    vaUid: '104103',
    vaWhsAddrid: '1024',
    vaAmount: '50',
    vaPayStatus: '9',
    vaPayBrief: 'LGID:159879097932324248',
    vaPaidTime: '1598790979',
    vaStatus: '9',
    createdTime: '1598790978',
    updatedTime: '1598851103',
    createdAt: '2020-08-30 20:36:18',
    updatedAt: '2020-08-31 13:18:23',
    vaTypeName: '開箱驗貨',
    parcelField: 'ooba',
    vaPayStatusName: '已付款',
    vaStatusName: '已完成'
  },
  {
    vaOid: 'V3580836188589',
    vaPclid: '548910',
    vaType: 're',
    vaUid: '104103',
    vaWhsAddrid: '1024',
    vaAmount: '25',
    vaPayStatus: '9',
    vaPayBrief: 'LGID:159879097911441229',
    vaPaidTime: '1598790979',
    vaStatus: '9',
    createdTime: '1598790978',
    updatedTime: '1598851103',
    createdAt: '2020-08-30 20:36:18',
    updatedAt: '2020-08-31 13:18:23',
    vaTypeName: '包裝氣泡棉',
    parcelField: 'reinforce',
    vaPayStatusName: '已付款',
    vaStatusName: '已完成'
  },
  {
    vaOid: 'V3580836188659',
    vaPclid: '548910',
    vaType: 'st',
    vaUid: '104103',
    vaWhsAddrid: '1024',
    vaAmount: '100',
    vaPayStatus: '9',
    vaPayBrief: 'LGID:159879097921892556',
    vaPaidTime: '1598790979',
    vaStatus: '9',
    createdTime: '1598790978',
    updatedTime: '1598851103',
    createdAt: '2020-08-30 20:36:18',
    updatedAt: '2020-08-31 13:18:23',
    vaTypeName: '填充氣柱袋',
    parcelField: 'stuffing',
    vaPayStatusName: '已付款',
    vaStatusName: '已完成'
  }],
  cnorder: {},
  isStorage: true,
  enabledChose: true,
  showInputDescTips: false,
  exceedVolumeLimitAir: false,
  exceedVolumeLimitSe: false,
  exceedWeightLimitAir: false,
  exceedWeightLimitSe: false,
  singleMaxVolume: false,
  isMold: true,
  isTwt: false,
  canAir: true,
  canSe: true,
  chosed: false,
  downDay: 30,
  isExample: true,
}
export default [
  {
    ...JSON.parse(JSON.stringify(parcel))
  },
  {
    ...JSON.parse(JSON.stringify(parcel)),
    pclid: 'eg範例包裹2',
    isStorage: false,
    enabledChose: false,
    vaorders: [],
  },
]
